import { Data_getInstance2o7c2m6692afy as Data_getInstance } from './adapter/CreateSecretMutation_ResponseAdapter.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  equals2au1ep9vhcato as equals,
  getStringHashCode26igk1bx568vk as getStringHashCode,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Companion_getInstanceoymipm3rjnhd as Companion_getInstance } from './type/Mutation.mjs';
import { Builder320ghmibyd2no as Builder } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import { CreateSecretMutationSelections_getInstancewalai12czjs9 as CreateSecretMutationSelections_getInstance } from './selections/CreateSecretMutationSelections.mjs';
import { CreateSecretMutation_VariablesAdapter_instance159o51cg8r2j3 as CreateSecretMutation_VariablesAdapter_instance } from './adapter/CreateSecretMutation_VariablesAdapter.mjs';
import { Mutationkenyz0l5btz as Mutation } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Mutation.mjs';
import { ApolloAdaptableWith1g871415y7ifs as ApolloAdaptableWith } from '../../../../../../apollo-kotlin-apollo-annotations/com/apollographql/apollo/annotations/ApolloAdaptableWith.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data() {
  if (DataClass === VOID) {
    class $ {
      constructor(createSecret) {
        this.v6f_1 = createSecret;
      }
      toString() {
        return 'Data(createSecret=' + toString(this.v6f_1) + ')';
      }
      hashCode() {
        return this.v6f_1 == null ? 0 : this.v6f_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Data()))
          return false;
        if (!equals(this.v6f_1, other.v6f_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Data', VOID, VOID, VOID, VOID, VOID, {1: Data_getInstance});
    DataClass = $;
  }
  return DataClass;
}
var CreateSecretClass;
function CreateSecret() {
  if (CreateSecretClass === VOID) {
    class $ {
      constructor(secretId, description, createdTimestamp, lastUsedTimestamp, secretToken) {
        this.w6f_1 = secretId;
        this.x6f_1 = description;
        this.y6f_1 = createdTimestamp;
        this.z6f_1 = lastUsedTimestamp;
        this.a6g_1 = secretToken;
      }
      toString() {
        return 'CreateSecret(secretId=' + this.w6f_1.toString() + ', description=' + this.x6f_1 + ', createdTimestamp=' + this.y6f_1.toString() + ', lastUsedTimestamp=' + toString(this.z6f_1) + ', secretToken=' + this.a6g_1 + ')';
      }
      hashCode() {
        var result = this.w6f_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.x6f_1) | 0;
        result = imul(result, 31) + this.y6f_1.hashCode() | 0;
        result = imul(result, 31) + (this.z6f_1 == null ? 0 : this.z6f_1.hashCode()) | 0;
        result = imul(result, 31) + getStringHashCode(this.a6g_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CreateSecret()))
          return false;
        if (!this.w6f_1.equals(other.w6f_1))
          return false;
        if (!(this.x6f_1 === other.x6f_1))
          return false;
        if (!this.y6f_1.equals(other.y6f_1))
          return false;
        if (!equals(this.z6f_1, other.z6f_1))
          return false;
        if (!(this.a6g_1 === other.a6g_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'CreateSecret');
    CreateSecretClass = $;
  }
  return CreateSecretClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.b6g_1 = obj(Data_getInstance());
        this.c6g_1 = (new (Builder())('data', Companion_getInstance().y6g_1)).g46(CreateSecretMutationSelections_getInstance().a6h_1).v39();
        this.d6g_1 = 'ebc30c0645cf276dd3d78eb42594ec195bdc601bd1d9fe71ba29e8b002fabc48';
        this.e6g_1 = 'createSecret';
      }
      b6h() {
        return 'mutation createSecret($input: CreateSecretInput!) { createSecret(input: $input) { secretId description createdTimestamp lastUsedTimestamp secretToken } }';
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var CreateSecretMutationClass;
function CreateSecretMutation() {
  if (CreateSecretMutationClass === VOID) {
    class $ {
      constructor(input) {
        Companion_getInstance_0();
        this.c6h_1 = input;
      }
      d6h() {
        return 'ebc30c0645cf276dd3d78eb42594ec195bdc601bd1d9fe71ba29e8b002fabc48';
      }
      operationId() {
        return this.d6h();
      }
      z49() {
        return Companion_getInstance_0().b6h();
      }
      e6h() {
        return 'createSecret';
      }
      operationName() {
        return this.e6h();
      }
      d49(writer, customScalarAdapters, withDefaultValues) {
        CreateSecretMutation_VariablesAdapter_instance.f6h(writer, this, customScalarAdapters, withDefaultValues);
      }
      c49() {
        return Companion_getInstance_0().b6g_1;
      }
      toString() {
        return 'CreateSecretMutation(input=' + this.c6h_1.toString() + ')';
      }
      hashCode() {
        return this.c6h_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CreateSecretMutation()))
          return false;
        if (!this.c6h_1.equals(other.c6h_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'CreateSecretMutation', VOID, VOID, [Mutation()]);
    CreateSecretMutationClass = $;
  }
  return CreateSecretMutationClass;
}
//region block: exports
export {
  CreateSecret as CreateSecretg99oj6r6hso0,
  Data as Data1ybn66w6c74sz,
  CreateSecretMutation as CreateSecretMutation3m5frrt825225,
};
//endregion

//# sourceMappingURL=CreateSecretMutation.mjs.map
